export default __webpack_public_path__ + "a5cb654443f7149eb89c3dc55cf25846.svg";